import BaseControl from "./BaseControl"
import Label from "./Label"

const LabelControl = ({text="",value="",caption="",color="", textColor=""}) => {
    return <BaseControl textColor={textColor} caption={caption} text={text}>
        <Label color={color} fontWeight="400" textAlign='end' padding="">
            {value}
        </Label>
    </BaseControl>
}

export default LabelControl